const serviceTypeCodes = {
  EUROSTAR: 'ES',
  THALYS: 'TH',
  GREENSPEED: 'ER',
  SNCF: 'SN',
  SNCB: 'SNCB',
  DB: 'DB',
  NS: 'NS'
};

export const EUROSTAR_CARRIERS = [serviceTypeCodes.EUROSTAR, serviceTypeCodes.GREENSPEED];

export default serviceTypeCodes;
